import api from './api'

// Function to get the API base URL (for error messages)
const getBaseUrl = () => {
  return api.defaults.baseURL;
};

export default {
  // Utility function to get the base URL for error reporting
  getBaseUrl,
  
  // Get all users
  getUsers() {
    return api.get('/users')
  },
  
  // Get a single user by ID
  getUser(id) {
    return api.get(`/users/${id}`)
  },
  
  // Create a new user
  createUser(userData) {
    return api.post('/users', userData)
  },
  
  // Update an existing user
  updateUser(id, userData) {
    return api.put(`/users/${id}`, userData)
  },
  
  // Delete a user
  deleteUser(id) {
    return api.delete(`/users/${id}`)
  }
}